'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _KendoChart = require('../KendoChart');

var _KendoChart2 = _interopRequireDefault(_KendoChart);

var _KendoChartSeriesItem = require('../KendoChartSeriesItem');

var _KendoChartSeriesItem2 = _interopRequireDefault(_KendoChartSeriesItem);

var _KendoStockChart = require('../KendoStockChart');

var _KendoStockChart2 = _interopRequireDefault(_KendoStockChart);

var _KendoSparkline = require('../KendoSparkline');

var _KendoSparkline2 = _interopRequireDefault(_KendoSparkline);

var _KendoSparklineSeriesItem = require('../KendoSparkline/KendoSparklineSeriesItem');

var _KendoSparklineSeriesItem2 = _interopRequireDefault(_KendoSparklineSeriesItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KendoChartInstaller = function () {
    function KendoChartInstaller() {
        _classCallCheck(this, KendoChartInstaller);
    }

    _createClass(KendoChartInstaller, null, [{
        key: 'install',
        value: function install(Vue) {
            Vue.component(_KendoChart2.default.name, _KendoChart2.default);
            Vue.component(_KendoChartSeriesItem2.default.name, _KendoChartSeriesItem2.default);
            Vue.component(_KendoStockChart2.default.name, _KendoStockChart2.default);
            Vue.component(_KendoSparkline2.default.name, _KendoSparkline2.default);
            Vue.component(_KendoSparklineSeriesItem2.default.name, _KendoSparklineSeriesItem2.default);
        }
    }]);

    return KendoChartInstaller;
}();

exports.default = KendoChartInstaller;

// Automatic installation if Vue has been added to the global scope.

if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoChartInstaller);
}